import React from "react";
import { Popover } from "@headlessui/react";
import { GoPaperclip } from "react-icons/go";
import { MdClose, MdDelete } from "react-icons/md";

const AttachmentPopover = ({ 
  attachmentKey, 
  attachments, 
  onFileSelect, // Now expects a direct callback instead of passing attachmentKey
  onAddMoreAttachments,
  onRemoveAttachment, 
  onOpenImage,
  openPopoverKey,
  setOpenPopoverKey,
  className = "",
  documentCount = 0
}) => {
  const count = attachments[attachmentKey]?.length || documentCount;

  return (
    <div className="flex items-center gap-1 relative">
      <Popover>
        <Popover.Button
          className={`flex items-center justify-center ${className}`}
          onClick={(e) => {
            e.preventDefault();
            onFileSelect(); // Call the callback directly without passing attachmentKey
          }}
        >
          <GoPaperclip className="w-5 h-5 text-blue-600 cursor-pointer" />
        </Popover.Button>
        {openPopoverKey === attachmentKey && (
          <>
            {/* Backdrop for outside click */}
            <div
              className="fixed inset-0 z-40"
              onClick={() => setOpenPopoverKey(null)}
              aria-hidden="true"
            />
            <Popover.Panel
              static
              className="absolute z-50 left-10 -top-16 w-80 bg-white rounded-lg shadow-lg border border-gray-200"
            >
              <div className="p-4">
                <div className="flex items-center justify-between mb-4">
                  <h3 className="text-lg font-semibold text-gray-900">
                    Attachments
                  </h3>
                  <button onClick={() => setOpenPopoverKey(null)}>
                    <MdClose className="w-5 h-5 text-gray-400 hover:text-gray-600 cursor-pointer" />
                  </button>
                </div>
                <div className="space-y-2 mb-4">
                  {attachments[attachmentKey]?.map((file, index) => (
                    <div
                      key={index}
                      className="flex items-center justify-between p-2 bg-gray-50 rounded"
                    >
                      <span
                        className="text-sm text-blue-600 cursor-pointer hover:underline flex-1 truncate"
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          onOpenImage(file.url);
                        }}
                      >
                        {file.name}
                      </span>
                      <button
                        onClick={() => onRemoveAttachment(attachmentKey, index)}
                        className="ml-2 text-gray-400 hover:text-red-500"
                      >
                        <MdDelete className="w-4 h-4" />
                      </button>
                    </div>
                  ))}
                </div>
                <button
                  onClick={() => onAddMoreAttachments(attachmentKey)}
                  className="flex items-center gap-2 text-blue-600 hover:underline text-sm"
                >
                  <GoPaperclip className="w-4 h-4" />
                  Add More Attachments
                </button>
              </div>
            </Popover.Panel>
          </>
        )}
      </Popover>
      {count > 0 && <span className="text-base text-gray-600">{count}</span>}
    </div>
  );
};

export default AttachmentPopover;
